import form from './form';
import survey from './survey';
import statistics from './statistics';

export default [form(), survey(), statistics()];
